import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { authStore, userSurveysStore } from '@/stores';
  import { onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useToast } from 'bootstrap-vue-3';
  import { ColorVariants, CallbackSessionKey, CallbackOriginSessionKey } from '@/constants';
  import { useI18n } from 'vue-i18n';
  import { loginGoBack } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const toast = useToast();
  const route = useRoute();
  const router = useRouter();

  async function loginCode() {
    let loginFun = null;
    switch (route.name) {
      case 'login.tc':
        loginFun = authStore.loginTc();
        break;
      case 'login.kakao':
        loginFun = authStore.loginKakao();
        break;
      case 'login.naver':
        loginFun = authStore.loginNaver();
        break;
      case 'login.google':
        loginFun = authStore.loginGoogle();
        break;
      case 'login.line':
        loginFun = authStore.loginLine();
        break;
    }
    const data = await loginFun;
    toast.show({ title: t('Success'), body: t('Login success!') }, { variant: ColorVariants.success });
    await goBack();
    // 检查登录完成之后有没有问卷
    userSurveysStore.clearHistory();
    // 只是绑定，不需要弹窗
    if (!data?.is_bind_sns) {
      userSurveysStore.tryPopup('after_login');
    }
  }

  async function goBack() {
    const callback = (route.query.callback as string) || sessionStorage.getItem(CallbackSessionKey);
    const callbackOrigin = (route.query.callback_origin as string) || sessionStorage.getItem(CallbackOriginSessionKey);
    sessionStorage.removeItem(CallbackSessionKey);
    sessionStorage.removeItem(CallbackOriginSessionKey);
    // 有 callbackOrigin，表示是通过自定义域名跳过来登录的，跳回自定义域名，需要带上临时登录 token
    await loginGoBack({ callback: decodeURIComponent(callback || ''), callbackOrigin: decodeURIComponent(callbackOrigin || '') });
  }

  onMounted(async () => {
    const { code, error_description, error } = route.query;
    // https://sentry.beansmile-dev.com/beansmile/tc-minisite-web/issues/22200
    if (!code) {
      const errMsg = error_description || error;
      toast.show({ title: errMsg || t('oauth_login_fail') }, { variant: ColorVariants.danger });
      router.replace({ name: 'login' });
      throw new Error(`oauth 登录失败 - ${route.fullPath}`);
    }
    try {
      await loginCode();
    } catch (err: any) {
      if (err.status === 400 && err.code === 40007) {
        // 通过第三方授权登录，但是没有手机号，需要登录或注册
        router.replace({ name: 'login', query: { ...route.query, hiddOAuth: 1 } });
      } else if (authStore.isLogin) {
        // 如果是已登录状态，说明此操作是绑定，此时也需要跳回到原来的页面
        goBack();
      }
      throw err;
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})